import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import gsap from 'gsap';

const Dot = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 6px; height: 6px;
  border-radius: 50%;
  background: #22D3EE;
  pointer-events: none;
  z-index: 999999;
  will-change: transform;

  @media (hover: none) { display: none; }
`;

const Ring = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 34px; height: 34px;
  border-radius: 50%;
  border: 1.5px solid rgba(34, 211, 238, 0.55);
  pointer-events: none;
  z-index: 999998;
  will-change: transform;
  transition: width 0.2s, height 0.2s, border-color 0.2s, background 0.2s;

  &.grow {
    width: 52px;
    height: 52px;
    border-color: rgba(34, 211, 238, 0.35);
    background: rgba(34, 211, 238, 0.06);
  }

  @media (hover: none) { display: none; }
`;

const CustomCursor = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);

  useEffect(() => {
    const dot = dotRef.current;
    const ring = ringRef.current;
    if (!dot || !ring) return;
    if (window.matchMedia('(hover: none)').matches) return;

    gsap.set([dot, ring], { xPercent: -50, yPercent: -50 });

    const xDot  = gsap.quickTo(dot,  'x', { duration: 0.1,  ease: 'power3.out' });
    const yDot  = gsap.quickTo(dot,  'y', { duration: 0.1,  ease: 'power3.out' });
    const xRing = gsap.quickTo(ring, 'x', { duration: 0.42, ease: 'power3.out' });
    const yRing = gsap.quickTo(ring, 'y', { duration: 0.42, ease: 'power3.out' });

    const onMove = (e) => {
      xDot(e.clientX);  yDot(e.clientY);
      xRing(e.clientX); yRing(e.clientY);
    };

    const onEnter = () => ring.classList.add('grow');
    const onLeave = () => ring.classList.remove('grow');

    window.addEventListener('mousemove', onMove);

    const attach = () => {
      document.querySelectorAll('a, button, [role="button"], input, textarea, select').forEach(el => {
        el.addEventListener('mouseenter', onEnter);
        el.addEventListener('mouseleave', onLeave);
      });
    };
    attach();

    return () => {
      window.removeEventListener('mousemove', onMove);
      document.querySelectorAll('a, button, [role="button"], input, textarea, select').forEach(el => {
        el.removeEventListener('mouseenter', onEnter);
        el.removeEventListener('mouseleave', onLeave);
      });
    };
  }, []);

  return (
    <>
      <Dot ref={dotRef} />
      <Ring ref={ringRef} />
    </>
  );
};

export default CustomCursor;
